import React, {useEffect, useState} from "react";
import * as actions from "../TransactionsAPI"
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {Button, Col, Row} from "react-bootstrap";
import './AdminTransactions.scss'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import PageHeader from "../../../../components/PageTitle";
import {faCloudDownloadAlt, faSync} from "@fortawesome/free-solid-svg-icons";
import SyncTransactionsModal from "./SyncTransactionsModal";
import AdminTransactionsFiltersModal from "./AdminTransactionsFiltersModal";
import AdminTransactionsTable from "./AdminTransactionsTable";
import SearchTransactionModal from "./SearchTransactionModal";

const AdminTransactions = ({actions}) => {
    const [transactions, setTransactions] = useState([])
    const [total, setTotal] = useState(0)
    const [showGetTransactionsModal, setShowGetTransactionsModal] = useState(false)
    const [showFiltersTransactionsModal, setShowFiltersTransactionsModal] = useState(false)
    const [rowSelected, setRowSelected] = useState([])
    const [showSearchTransactionModal, setShowSearchTransactionModal] = useState(false)
    const [refreshing, setRefreshing] = useState(false)
    const [tableParams, setTableParams] = useState({
        sort: 'DESC',
        sort_by: 'created',
        page: 1,
        per_page: 25
    })
    const [filters, setFilters] = useState({
        created_from: null,
        created_to: null,
        available_from: null,
        available_to: null,
        amount_from: null,
        amount_to: null,
        fee_amount_from: null,
        fee_amount_to: null,
        net_from: null,
        net_to: null,
        customer_ids: [],
        invoice_ids: [],
        client_ids: [],
        status: null,
        type: null,
    })

    const reload = () => {
        actions.fetchStripeTransactions({
            ...filters,
            ...tableParams,
            customer_ids: filters.customer_ids?.map(c => c.value),
            invoice_ids: filters.invoice_ids?.map(i => i.value),
            client_ids: filters.client_ids?.map(c => c.value),
        }, response => {
            setTransactions(response.transactions)
            setTotal(response.total_entries)
            setRefreshing(false)
        })
    }

    const refreshStripeTransactions = (stripe_ids) => {
        setRefreshing(true)
        actions.refreshTransactions(stripe_ids, () => reload())
    }
    const refreshStripePendingTransactions = () => {
        setRefreshing(true)
        actions.refreshPendingTransactions(() => reload())
    }

    const onSelectRow = (row, selected) => {
        if (selected) {
            setRowSelected([...rowSelected, row.id])
        } else {
            setRowSelected(rowSelected.filter(id => id !== row.id))
        }
    }

    const onSelectAllRows = (selected) => {
        if (selected) {
            if (transactions.length > 0) {
                setRowSelected(transactions.map(r => r.id))
            }
        } else {
            setRowSelected([])
        }
    }

    useEffect(() => {
        if (!showFiltersTransactionsModal) {
            reload()
        }
    }, [tableParams])

    useEffect(() => {
        reload()
    }, [])

    return <div id="admin_transactions">
        <Row>
            <Col xs={12} sm={3} className="transactions_header_wrapper">
                <PageHeader pageName="Transactions" pageDetail={` ${total} records`}/>
            </Col>
            <Col xs={12} sm={9} className="text-right">
                <Button bsStyle="success" className="transactions_btn ml-7 mt-5"
                        onClick={() => setShowSearchTransactionModal(true)}>
                    Search Stripe transaction
                    <FontAwesomeIcon icon="search" className="small-margin ml-6 no-right-margin"/>
                </Button>
                <Button
                    bsStyle="success"
                    className="transactions_btn ml-7 mt-5"
                    disabled={refreshing}
                    onClick={() => refreshStripePendingTransactions()}
                >
                    Refresh all pending transactions <FontAwesomeIcon icon={faSync} className="ml-7"/>
                </Button>
                <Button
                    bsStyle="success"
                    className="transactions_btn ml-7 mt-5"
                    disabled={rowSelected.length === 0 || refreshing}
                    onClick={() => refreshStripeTransactions(transactions.filter(t => rowSelected.includes(t.id)).map(t => t.stripe_id))}
                >
                    Refresh selected transactions <FontAwesomeIcon icon={faSync} className="ml-7"/>
                </Button>
                <Button
                    bsStyle="success"
                    className="transactions_btn ml-7 mt-5"
                    onClick={() => setShowGetTransactionsModal(true)}
                >
                    Get new transactions <FontAwesomeIcon icon={faCloudDownloadAlt} className="ml-7"/>
                </Button>
                <Button
                    className="transactions_btn ml-7 mt-5"
                    onClick={() => setShowFiltersTransactionsModal(true)}
                >
                    Filter {" "} <FontAwesomeIcon icon="search" className="small-margin"/>
                </Button>
            </Col>
        </Row>
        <Row>
            <AdminTransactionsTable
                transactions={transactions}
                tableParams={tableParams}
                total={total}
                rowSelected={rowSelected}
                refreshStripeTransactions={refreshStripeTransactions}
                onPageChange={(page, per_page) => setTableParams({...tableParams, page, per_page})}
                onSortChange={(sort_by, sort) => setTableParams({...tableParams, sort_by, sort})}
                onSelect={onSelectRow}
                onSelectAll={onSelectAllRows}
            />
        </Row>
        {showGetTransactionsModal && <SyncTransactionsModal
            onHide={() => setShowGetTransactionsModal(false)}
            getTransactionsFromStripe={actions.getTransactionsFromStripe}
            reload={reload}
        />}
        {showFiltersTransactionsModal && <AdminTransactionsFiltersModal
            onHide={() => setShowFiltersTransactionsModal(false)}
            onSave={(filters) => {
                setFilters(filters)
                setTableParams({...tableParams, page: 1})
            }}
            prevFilters={filters}
            searchForCustomer={actions.searchForCustomer}
            searchForInvoices={actions.searchForInvoices}
            searchForClients={actions.searchForClients}
        />}
        {showSearchTransactionModal &&
            <SearchTransactionModal
                onHide={() => setShowSearchTransactionModal(false)}
                searchTransaction={actions.searchTransaction}
            />}
    </div>
}

const mapDispatchToProps = dispatch => ({actions: bindActionCreators(actions, dispatch)})

export default connect(undefined, mapDispatchToProps)(AdminTransactions)